import React from "react";
import ArrayEditor from "./ArrayEditor";
import EditableInput from "./EditableInput";
import EditableSelect from "./EditableSelect";
import LargeArrayEditor from "./LargeArrayEditor";
import LargeObjectEditor from "./LargeObjectEditor";
import ObjectEditor from "./ObjectEditor";

const RecordEditor = ({
  editableEntries,
  formState,
  formError,
  onChange,
  onAddArrayItem,
  onRemoveArrayItem,
  onArrayItemChange,
  onAddObjectField,
  onRemoveObjectField,
  onObjectFieldChange,
  selectedArrayItemByKey,
  selectedObjectFieldByKey,
  onSelectArrayItem,
  onSelectObjectField,
}) => (
  <div className="space-y-4">
    {formError ? (
      <div className="rounded-2xl border border-rose-500/20 bg-rose-500/10 px-4 py-3 text-sm text-rose-100">
        {formError}
      </div>
    ) : null}

    {editableEntries.map((entry) => {
      const fieldInput =
        entry.editorVariant === "large-array" ? (
          <LargeArrayEditor
            entry={entry}
            arrayItems={formState[entry.key] || []}
            selectedIndex={Number(selectedArrayItemByKey[entry.key]) || 0}
            onSelectIndex={(value) => onSelectArrayItem(entry.key, value)}
            onAddItem={() => onAddArrayItem(entry.key)}
            onRemoveItem={(index) => onRemoveArrayItem(entry.key, index)}
            selectedItem={(formState[entry.key] || [])[Number(selectedArrayItemByKey[entry.key]) || 0] || null}
            onChangeItem={(index, value) => onArrayItemChange(entry.key, index, value)}
          />
        ) : entry.editorVariant === "large-object" ? (
          <LargeObjectEditor
            entry={entry}
            objectFields={formState[entry.key] || []}
            selectedIndex={Number(selectedObjectFieldByKey[entry.key]) || 0}
            onSelectIndex={(value) => onSelectObjectField(entry.key, value)}
            onAddField={() => onAddObjectField(entry.key)}
            onRemoveField={(index) => onRemoveObjectField(entry.key, index)}
            selectedField={(formState[entry.key] || [])[Number(selectedObjectFieldByKey[entry.key]) || 0] || null}
            onChangeField={(index, fieldName, value) =>
              onObjectFieldChange(entry.key, index, fieldName, value)
            }
          />
        ) : entry.mode === "array" ? (
          <ArrayEditor
            entry={entry}
            arrayItems={formState[entry.key] || []}
            onAddItem={() => onAddArrayItem(entry.key)}
            onRemoveItem={(index) => onRemoveArrayItem(entry.key, index)}
            onChangeItem={(index, value) => onArrayItemChange(entry.key, index, value)}
          />
        ) : entry.mode === "object" ? (
          <ObjectEditor
            entry={entry}
            objectFields={formState[entry.key] || []}
            onAddField={() => onAddObjectField(entry.key)}
            onRemoveField={(index) => onRemoveObjectField(entry.key, index)}
            onChangeField={(index, fieldName, value) =>
              onObjectFieldChange(entry.key, index, fieldName, value)
            }
          />
        ) : entry.mode === "select" ? (
          <EditableSelect
            value={formState[entry.key] ?? ""}
            onChange={(event) => onChange(entry.key, event.target.value)}
            ariaLabel={entry.label}
            options={entry.options}
          />
        ) : (
          <EditableInput
            value={formState[entry.key] ?? ""}
            onChange={(event) => onChange(entry.key, event.target.value)}
            multiline={entry.mode === "textarea"}
            rows={4}
            ariaLabel={entry.label}
          />
        );
          console.log(entry.key ,entry.label);
      return (
        <label key={entry.key} className="block">
          <span className="mb-2 block text-xs font-medium uppercase tracking-[0.12em] text-slate-500">
           { entry.key === "ai_name" ? "Company Name" : entry.label}
          </span>
          {fieldInput}  
        </label>
      );
    })}
  </div>
);

export default RecordEditor;
